function initiateRumSpicesSelector() {
  document
    .querySelectorAll('.spices-selection-block')
    .forEach(block => {
      new window.RumSpicesSelection(block);
    });
}

if (!window.RumSpicesSelection) {
  window.RumSpicesSelection =
    class RumSpicesSelection {
      constructor(blockElement) {
        this.blockElement = blockElement;
        this.maxSpices = parseInt(blockElement.dataset.maxSpices) || 5;
        this.counterElement = blockElement.querySelector('.selected-count');
        this.SpiceItems = blockElement.querySelectorAll('.spices-item');
        this.selectedSpices = [];
        
        this.#init();
      }
      
      #init() {
        this.#addEventListeners();
        this.#updateCounter();
      }
      
      #addEventListeners() {
        this.SpiceItems.forEach(item => {
          this.#addClickHandler(item);

          item.removeEventListener('click', item._clickHandler);
          item.addEventListener('click', item._clickHandler);
        });
      }

      #addClickHandler(item) {
        if (!item._clickHandler) {
          item._clickHandler = () => {
            if (!item.classList.contains('disabled')) {
              this.#toggleSpice(item);
            }
          }
        }
      }

      #updateCounter() {
        this.counterElement.textContent = this.selectedSpices.length;

        // Disable/enable items based on selection limit
        this.SpiceItems.forEach(item => {
          if (!item.classList.contains('selected') && this.selectedSpices.length >= this.maxSpices) {
            item.classList.add('disabled');
          } else {
            item.classList.remove('disabled');
          }
        });
      }

      #toggleSpice(item) {
        const spiceId = item.dataset.spices;
        const isSelected = item.classList.contains('selected');

        if (isSelected) {
          // Remove spice
          this.selectedSpices = this.selectedSpices.filter(id => id !== spiceId);
          item.classList.remove('selected');
        } else if (this.selectedSpices.length < this.maxSpices) {
          // Add spice
          this.selectedSpices.push(spiceId);
          item.classList.add('selected');
        }

        this.#updateCounter();

        // Dispatch custom event for integration with other components
        document.dispatchEvent(new CustomEvent('spices-changed', {
          detail: {
            selectedSpices: this.selectedSpices
          }
        }));
      }

      #getSelectedSpices() {
        return this.selectedSpices;
      }

      reset() {
        this.selectedSpices = [];
        this.SpiceItems.forEach(item => {
          item.classList.remove('selected');
        });
        this.#updateCounter();
      }
    }
  initiateRumSpicesSelector();
}

document.addEventListener('DOMContentLoaded', () => {
  initiateRumSpicesSelector();
});

document.addEventListener('modal-opened', () => {
  initiateRumSpicesSelector();
});
